import { Component } from "react";
import { isChunkLoadError, tryReloadOnce } from "../lib/chunkReload";

// Rete di sicurezza: cattura qualsiasi errore di rendering/caricamento e mostra
// una schermata di recupero invece di una pagina bianca. Sui ChunkLoadError
// (asset vecchi dopo un deploy) tenta un ricaricamento automatico.
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    if (isChunkLoadError(error)) {
      // Se ricarica, la pagina si rimonta con gli asset aggiornati.
      tryReloadOnce();
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="error-boundary"
          className="min-h-screen bg-[#FDFBF7] flex items-center justify-center p-6"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          <div className="text-center max-w-md">
            <h1 className="text-2xl font-black text-[#0A0A0A] mb-3">Qualcosa è andato storto</h1>
            <p className="text-[#0A0A0A] mb-6">
              L'app è stata aggiornata o la connessione si è interrotta. Ricarica la pagina per continuare.
            </p>
            <button
              type="button"
              data-testid="error-boundary-reload"
              onClick={() => window.location.reload()}
              className="bg-[#FDE047] text-[#0A0A0A] border-2 border-[#0A0A0A] font-bold uppercase px-6 py-3 shadow-[3px_3px_0px_#0A0A0A] hover:bg-yellow-300 cursor-pointer"
            >
              Ricarica
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
